<template>
  <div>
    <!-- <div class="split-line"></div> -->
    <h3 class="float-left">聊天资料</h3>
    <el-table
      :data="imData"
      border
      style="width: 100%"
      header-row-class-name="common-table-header"
      row-class-name="common-table-row"
      class="common-table"
    >
      <el-table-column label="医生/患者">
        <template slot-scope="scope">
          {{ scope.row.isDoc | DocFilter }}
        </template>
      </el-table-column>
      <el-table-column prop="uName" label="姓名/ID"></el-table-column>
      <el-table-column label="内容">
        <template slot-scope="scope">
          <span v-if="scope.row.type === 'Text'">
            {{ scope.row.content }}
          </span>
          <span v-if="['SysText', 'Video'].includes(scope.row.type)" v-html="handlerContent(scope.row)"></span>
          <a v-else-if="scope.row.type === 'Image'" :href="scope.row.content | addImagePrefix" target="_blank">
            <img class="preview-image" :src="scope.row.content | addImagePrefix" />
          </a>
        </template>
      </el-table-column>
      <el-table-column label="时间">
        <template slot-scope="scope">
          {{ scope.row.timeStr }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<style lang="scss" scoped>
.preview-image {
  width: 100px;
}
</style>
<script>
export default {
  name: 'imHistory',
  props: {
    imData: Array
  },
  data() {
    return {};
  },
  filters: {
    DocFilter(isDoc) {
      return isDoc ? '医生' : '患者';
    }
  },
  methods: {
    handlerContent({ type, content }) {
      return type === 'Video' || /^https?:\/\/.+\.mp4$/.test(content.toLowerCase())
        ? `<video width="100%" height="100px" controls="controls" src="${content}"></video>`
        : '无';
    }
  }
};
</script>
